'use es6';

import App from 'AdsUI/app';

require.context('bender-url!../imgs', true);

new App().start();